import Box from '@mui/material/Box';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getLabelledCardSx,
  labelledCardDeletedLabelSx,
  labelledCardEndActionsSx,
  labelledCardLabelSx,
} from './labelledCardStyles';

interface CardItemProps {
  redirectTo?: string;
  label: string;
  EndIcon?: ReactElement;
  deleted?: boolean;
}

export const LabelledCard = (props: CardItemProps): ReactElement => {
  const navigate = useNavigate();

  const { redirectTo, label, deleted, EndIcon } = props;
  const isClickable = Boolean(redirectTo);

  return (
    <Box
      sx={getLabelledCardSx(isClickable)}
      onClick={() => {
        if (redirectTo) {
          navigate(redirectTo);
        }
      }}
    >
      <Box
        sx={[labelledCardLabelSx, ...(deleted ? [labelledCardDeletedLabelSx] : [])]}
      >
        {label}
      </Box>
      {EndIcon ? (
        <Box sx={labelledCardEndActionsSx}>{EndIcon}</Box>
      ) : null}
    </Box>
  );
};
